interface AddPackButtonProps {
  isInCart: boolean;
  isLoading: boolean;
  onAdd: () => void;
  onRemove: () => void;
}

export function AddPackButton({ isInCart, isLoading, onAdd, onRemove }: AddPackButtonProps) {
  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center rounded-md bg-gray-200 px-4 py-3 text-sm font-medium text-gray-500">
        <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" />
        Procesando...
      </div>
    );
  }

  if (isInCart) {
    return (
      <div className="flex w-full gap-2">
        <div className="flex flex-1 items-center justify-center rounded-md border border-green-300 bg-green-50 px-4 py-3 text-sm font-medium text-green-800">
          <i className="fa fa-check mr-2" />
          Pack Agregado
        </div>
        <button
          type="button"
          className="flex-shrink-0 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm font-medium text-red-700 transition-colors hover:bg-red-600 hover:text-white hover:border-red-600"
          onClick={onRemove}
        >
          <i className="fa fa-times mr-1.5" />
          Quitar
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      className="flex w-full items-center justify-center rounded-md bg-green-600 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-green-700"
      onClick={onAdd}
    >
      <i className="fa fa-cart-plus mr-2" />
      Agregar al Carrito
    </button>
  );
}
